import React from 'react'
import { ApproveAndInclueInReportIcon, RejectIcon } from '../messageBox/Messages/AttachmentMessage/icons'
import { useDispatch } from 'react-redux'
import IconToolTip from '../../../common/IconToolTip'
import { useSelector } from 'react-redux'
import { updateMediaStatus } from '../../../actions/chat'

function ApprovedRejectIcon({ showApprovalOptions, is_approved, is_rejected, rejector, approver, messageId, attachmentId, isCardMessage, chat_id }) {
    const dispatch = useDispatch()
    const { approveOrRejectMediaLoadingIdSet, approveOrRejectCardMessageLoadingIdSet } = useSelector(state => state.loading);

    return (
        <>
            {showApprovalOptions.showApprove && (
                <>
                    <RejectIcon onClick={() => dispatch(updateMediaStatus({ message_id: messageId, chat_id, id: attachmentId, payload: { is_rejected: true, is_approved: false, media_id: attachmentId }, formName: 'media' }))} isLoading={isCardMessage ? approveOrRejectCardMessageLoadingIdSet.has(messageId) : approveOrRejectMediaLoadingIdSet?.has(attachmentId)} isCardMessage={isCardMessage} />
                    <ApproveAndInclueInReportIcon onClick={() => dispatch(updateMediaStatus({ message_id: messageId, chat_id, id: attachmentId, payload: { is_approved: true, is_rejected: false, media_id: attachmentId }, formName: 'media' }))} isLoading={isCardMessage ? approveOrRejectCardMessageLoadingIdSet.has(messageId) : approveOrRejectMediaLoadingIdSet?.has(attachmentId)} isCardMessage={isCardMessage} />
                </>
            )}
            {is_approved ? (
                <>
                    <IconToolTip title={approver ? `Approved by ${approver?.display_name} and will be included in Report` : `Approved`}>
                        <div
                            className='flex items-center gap-1 text-font09 text-scogoorange border border-scogoorange rounded px-2  '
                            style={{ backgroundColor: 'rgba(255,255,255, 0.6)' }}
                        >
                            <span className='material-icons text-font08'>check</span>
                            Approved
                        </div>
                    </IconToolTip>
                    {showApprovalOptions.isAdmin ? <RejectIcon onClick={() => dispatch(updateMediaStatus({ message_id: messageId, chat_id, id: attachmentId, payload: { is_rejected: true, is_approved: false, media_id: attachmentId }, formName: 'media' }))} isLoading={isCardMessage ? approveOrRejectCardMessageLoadingIdSet.has(messageId) : approveOrRejectMediaLoadingIdSet?.has(attachmentId)} isCardMessage={isCardMessage} /> : null}
                </>
            ) : null}
            {is_rejected ? (
                <IconToolTip title={rejector ? `Rejected by ${rejector?.display_name}` : `Rejected`}>
                    <div
                        className='flex items-center gap-1 text-font09 text-scogoclosed border border-scogoclosed rounded px-2  '
                        style={{ backgroundColor: 'rgba(255,255,255, 0.6)' }}
                    >
                        <span className='material-icons text-font08'>block</span>
                        Rejected
                    </div>
                </IconToolTip>
            ) : null}
        </>
    )
}

export default ApprovedRejectIcon